import { render, staticRenderFns } from "./ConceptTag.vue?vue&type=template&id=a13da5ea&scoped=true"
import script from "./ConceptTag.vue?vue&type=script&lang=js"
export * from "./ConceptTag.vue?vue&type=script&lang=js"
import style0 from "./ConceptTag.vue?vue&type=style&index=0&id=a13da5ea&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13da5ea",
  null
  
)

export default component.exports